
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"41","viewBox":"0 0 40 41","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.2848 6.93573C31.7528 4.71144 25.5907 4.62707 19.9998 6.69907C14.409 4.62707 8.24686 4.71144 2.71484 6.93573C2.4053 7.0594 2.13996 7.27303 1.95308 7.54904C1.76621 7.82504 1.66638 8.15075 1.6665 8.48407V33.5457C1.6664 33.8181 1.73305 34.0863 1.86062 34.327C1.98818 34.5676 2.17277 34.7733 2.39825 34.9261C2.62372 35.0789 2.88319 35.1741 3.15397 35.2034C3.42475 35.2326 3.69858 35.1951 3.9515 35.0941C8.90195 33.102 14.4311 33.102 19.3815 35.0941C19.5669 35.1643 19.7632 35.2016 19.9615 35.2041C19.9748 35.2041 19.9865 35.2041 19.9998 35.2041C20.0132 35.2041 20.0248 35.2041 20.0382 35.2041C20.2364 35.2016 20.4327 35.1643 20.6182 35.0941C25.5686 33.102 31.0977 33.102 36.0482 35.0941C36.301 35.1953 36.5748 35.2331 36.8456 35.204C37.1164 35.1749 37.3759 35.08 37.6015 34.9274C37.8271 34.7745 38.0118 34.5686 38.1394 34.3277C38.267 34.0868 38.3335 33.8183 38.3332 33.5457V8.48407C38.3333 8.15075 38.2335 7.82504 38.0466 7.54904C37.8597 7.27303 37.5944 7.0594 37.2848 6.93573ZM18.3332 31.2274C13.9809 29.9525 9.35498 29.9473 4.99984 31.2124V9.64407C9.32431 8.17614 14.0135 8.18376 18.3332 9.66573V31.2274ZM34.9998 31.2124C30.6449 29.9508 26.0214 29.9508 21.6665 31.2124V9.66573C25.9862 8.18376 30.6754 8.17614 34.9998 9.64407V31.2124Z","fill":"#006ABC"}})])
          )
        }
      }
    